import React from 'react'
import { useAppDispatch } from '../../../redux/storeExports'
import { fetchUsers, removeUser, removeExecutiveUser, fetchCode } from '../../../redux/corporateService'
import GenericModal from './GenericModal'
import { FetchExecutiveUsers } from '@meprism/shared/src/redux/profile/ProfileSlice'
interface SuccessLoginModalProps {
  open: boolean
  setOpen: (open: boolean) => void
  muid: any
  isExecutive?: boolean
}

const ConfirmationModal = (props: SuccessLoginModalProps) => {
  const dispatch = useAppDispatch()
  const handleDelete=()=>{
    if (props.isExecutive){
      onExecutiveDelete()
    }
    else{
      onDelete()
    }
  }
  const onDelete = async () => {
    props.setOpen(false)
    await dispatch(removeUser(props.muid as string)).unwrap()
    dispatch(fetchUsers())
  }
  const onExecutiveDelete = async () => {
    props.setOpen(false)
    await dispatch(removeExecutiveUser(props.muid as string))
    const code = await dispatch(fetchCode()).unwrap()
    await dispatch(FetchExecutiveUsers(code))
  }
  const handleClose = () => {
    props.setOpen(false)
  }
  return (
    <GenericModal
      open={props.open}
      onClose={handleClose}
      title="Are you sure?"
      message="Do you really want to remove? This action cannot be undone."
      confirmText="Delete"
      cancelText="Cancel"
      onConfirm={handleDelete}
    />
  )
}

export default ConfirmationModal
